// @ts-expect-error see app/assets/components/loadMonacoEditor.ts
import { loadMonacoEditor } from 'components/loadMonacoEditor';
import type * as Monaco from 'monaco-editor';

export type MonacoEditor = typeof Monaco;

export const diagramLanguageProvider = async () => {
  const monaco = (await loadMonacoEditor()) as MonacoEditor;

  // Register a new language
  monaco.languages.register({ id: 'ahaDiagrams' });

  // Register a tokens provider for the language
  monaco.languages.setMonarchTokensProvider('ahaDiagrams', {
    ignoreCase: true,
    brackets: [{ open: '{', close: '}', token: 'delimiter.curly' }],
    tokenizer: {
      root: [
        // whitespace
        { include: '@whitespace' },

        [/flowchart|cycle|hierarchy/, 'diagramType'],
        [/<->|-->|->|---|--|<--|<-/, 'connector'],
        [/[{},]/, 'propertyPunctuation'],
        [/[/#:;|\-<]/, 'punctuation'],
        [/[a-zA-Z0-9]+:/, 'key'],
      ],

      comment: [
        [/[^/*]+/, 'comment'],
        // [/\/\*/, 'comment', '@push'], // nested comment
        ['\\*/', 'comment', '@pop'],
        [/[/*]/, 'comment'],
      ],

      whitespace: [
        [/\/\*/, 'comment', '@comment'],
        [/\/\/.*$/, 'comment'],
      ],
    },
  });

  // Define a new theme that contains only rules that match this language
  monaco.editor.defineTheme('ahaDiagramsTheme', {
    base: 'vs',
    inherit: false,
    rules: [
      { token: 'propertyPunctuation', foreground: '#BA2F48' },
      { token: 'punctuation', foreground: '#51A150' },
      { token: 'diagramType', foreground: '#99329F' },
      { token: 'connector', foreground: '#FFA500' },
      { token: 'key', foreground: '#659F58' },
      { token: 'value', foreground: '#404248' },
      { token: 'comment', foreground: '#A0A1A7', fontStyle: 'italic' },
    ],
    colors: {
      'editor.background': '#FBFBFB',
      'editor.foreground': '#32369F',
      'editorLineNumber.foreground': '#C3C7CD',
      'editorLineNumber.activeForeground': '#C3C7CD',
    },
  });

  return monaco;
  /*
// Register a completion item provider for the new language
monaco.languages.registerCompletionItemProvider('ahaDiagrams', {
  provideCompletionItems: (model, position) => {
    var word = model.getWordUntilPosition(position);
    var range = {
      startLineNumber: position.lineNumber,
      endLineNumber: position.lineNumber,
      startColumn: word.startColumn,
      endColumn: word.endColumn,
    };
    var suggestions = [
      {
        label: 'simpleText',
        kind: monaco.languages.CompletionItemKind.Text,
        insertText: 'simpleText',
        range: range,
      },
      {
        label: 'testing',
        kind: monaco.languages.CompletionItemKind.Keyword,
        insertText: 'testing(${1:condition})',
        insertTextRules:
          monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        range: range,
      },
      {
        label: 'ifelse',
        kind: monaco.languages.CompletionItemKind.Snippet,
        insertText: [
          'if (${1:condition}) {',
          '\t$0',
          '} else {',
          '\t',
          '}',
        ].join('\n'),
        insertTextRules:
          monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        documentation: 'If-Else Statement',
        range: range,
      },
    ];
    return { suggestions: suggestions };
  },
}); */
};
